import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Employee } from 'src/app/models/Employees';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { ParamService } from 'src/app/services/param.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-hierarchy',
  templateUrl: './hierarchy.component.html',
  styleUrls: ['./hierarchy.component.scss'],
})
export class HierarchyComponent implements OnInit {

  @Input() onlyAssigned: boolean = false;
  @Input() hierarchy: any;
  @Output() onSelect = new EventEmitter<string>();
  @Input() emp: Employee;
  constructor(private alert: AlertService, private router: Router, public paramservice: ParamService, private empService: EmployeeSService, private toast: ToastService, private location: Location) { }

  ngOnInit() { }

  getCount() {
    this.hierarchy.showChild = true;
    this.getStateWiseData();
  }

  getStateWiseData() {
    let base = '';
    switch (this.hierarchy.type) {
      case 'district':
        base = 'pincode';
        break;
      case 'state':
        base = 'district';
        break;
      case 'pincode':
        base = 'area';
        break;
    }
    if (base) {
      console.log(base, this.hierarchy.type, this.hierarchy.name);
      this.empService.getCount('user_pd', base, [[this.hierarchy.type, this.hierarchy.name]]).then((stateCounts) => {
        for (let state of this.hierarchy.childList) {
          state.count = stateCounts[state.name] ?? 0;
        }
      });
      this.empService.getCount('invite', base, [[this.hierarchy.type, this.hierarchy.name], ['status', ['Requested', 'LoggedIn'], 'in']]).then((stateCounts) => {
        for (let state of this.hierarchy.childList) {
          state.pendingCount = stateCounts[state.name] ?? 0;
        }
      });
    }
  }

  onClick() {
    let filterList = [['user.user_pd.' + this.hierarchy.type, this.hierarchy.name]];
    this.paramservice.setData('filterList', filterList);
    this.router.navigate(['/user-list']);
  }

  masterAction() {
    this.alert.showAlert(this.hierarchy.name + " -  " + this.hierarchy.code + " Manager", "Are you sure you want to Assign " + this.hierarchy.name + " to " + this.emp.user.name, "Set").then(() => {
      this.emp.assigned_area = this.emp.assigned_area ?? [];
      this.emp.assigned_area.push(this.hierarchy.name);
      this.empService.saveObject(this.emp, false).then(() => {
        this.toast.success("Area Assigned successfully");
        this.location.back();
      })
    })
  }
  removeAm(emp: Employee, hierarchy) {
    this.alert.showAlert("Remove " + emp.user.name + " Ji from " + hierarchy, null, "Delete").then(() => {
      console.log(emp, emp.assigned_area, hierarchy);
      emp.assigned_area = emp.assigned_area.filter(x => x != hierarchy);
      console.log(emp.assigned_area);
      this.empService.saveObject(emp);
    })
  }
}
